<itl-loading-indicator *ngIf="loading"></itl-loading-indicator>
<div *ngIf="!loading">
  <itl-toggle
    *ngIf="canSetDeliveryDateUnknown"
    title="Lieferdatum unbekannt"
    [ngModel]="order.deliveryDateUnknown"
    (ngModelChange)="deliveryDateUnknownToggled($event)"
  ></itl-toggle>
  <div *ngIf="!order.deliveryDateUnknown" class="timeframe">
    <itl-info-box *ngIf="postalCodeInfoText && order.deliveryAddress?.postalCode"
      ><div [innerText]="postalCodeInfoText"></div
    ></itl-info-box>
    <itl-date-time
      [title]="'order.deliveryDate' | translate"
      [min]="minDate"
      [(ngModel)]="order.deliveryDate"
      (change)="deliveryDateChanged()"
      [formControl]="deliveryDate"
      [required]="true"
      icon="alberta-lorry"
      [placeholder]="'order.deliveryDate_placeholder' | translate"
    ></itl-date-time>

    <div class="scope">
      <itl-date-time
        [title]="'order.startDate' | translate"
        [(ngModel)]="order.startDateVM"
        [formControl]="startDate"
        (ngModelChange)="scopeChanged()"
        [required]="true"
        icon="alberta-play"
      ></itl-date-time>
      <itl-date-time
        [title]="'order.endDate' | translate"
        [min]="minDate"
        [(ngModel)]="order.endDateVM"
        [formControl]="endDate"
        (ngModelChange)="scopeChanged()"
        [required]="true"
        icon="alberta-stop"
      ></itl-date-time>
    </div>
    <itl-checkbox-select
      [headerText]="'order.accountingMonths' | translate"
      [title]="'order.accountingMonths' | translate"
      [selectionItems]="accountingMonthNames"
      [(ngModel)]="order.accountingMonth"
      [formControl]="accountingMonth"
      [required]="true"
      icon="alberta-accounting-month"
      (ngModelChange)="accountingMonthChanged($event)"
    >
    </itl-checkbox-select>
    <ng-container *ngIf="orderTagsInConfig">
      <itl-checkbox-select
        *ngIf="orderTagsSelectStyle === 'multiple'"
        [headerText]="'order.tags' | translate"
        [placeholder]="'order.tags_Placeholder' | translate"
        [title]="'order.tags' | translate"
        [selectionItems]="orderTags"
        [formControl]="tags"
        [required]="orderTagsRequired"
        icon="alberta-dot"
      ></itl-checkbox-select>
      <itl-selection
        *ngIf="orderTagsSelectStyle === 'single'"
        [title]="'order.tags' | translate"
        [values]="orderTags"
        [formControl]="tags"
        [required]="orderTagsRequired"
        icon="alberta-dot"
      ></itl-selection>
    </ng-container>
  </div>

  <div class="reminder">
    <div class="toggle-wrapper">
      <itl-detail-item>
        <itl-detail-item-icon>
          <ion-icon name="alberta-ic-reminder"></ion-icon>
        </itl-detail-item-icon>
        <span class="title">{{ 'order.reminder' | translate }}</span>
      </itl-detail-item>
      <itl-toggle [(ngModel)]="hasReminder" (ngModelChange)="reminderToggled.emit(hasReminder)"></itl-toggle>
    </div>
    <ng-container *ngIf="hasReminder">
      <form [formGroup]="reminderForm" class="scope">
        <itl-date-time
          [formControl]="reminderDate"
          [title]="'order.date' | translate"
          [required]="true"
          [min]="minDate"
          icon="alberta-activity-date"
        ></itl-date-time>
        <itl-textarea
          [title]="'order.reminder' | translate"
          [formControl]="reminderText"
          [placeholder]="'order.reminderPlaceholder' | translate"
          icon="alberta-comment"
          [preventEnter]="true"
        ></itl-textarea>
      </form>
    </ng-container>
  </div>
  <itl-toggle
    *ngIf="showOrderPrescriberToggle"
    [title]="'order.edit.hospitalIsPrescriber' | translate"
    [(ngModel)]="order.isHospitalPrescriber"
    (ngModelChange)="isHospitalPrescriberChanged($event)"
  ></itl-toggle>
  <itl-selection
    *ngIf="deliveryInformationSelectionItems.length"
    [title]="'order.deliveryInformation' | translate"
    [values]="deliveryInformationSelectionItems"
    [(ngModel)]="order.deliveryInformation"
    [formControl]="deliveryInformation"
    [placeholder]="'order.chooseDeliveryInformation' | translate"
    [required]="deliveryInformationRequired"
    icon="alberta-document-info"
    (change)="resetStartTime($event)"
  >
  </itl-selection>
  <itl-date-time
    [title]="'patient.edit.deliveryStartTime' | translate"
    *ngIf="showTimeSelection"
    [(ngModel)]="startTime"
    [formControl]="deliveryStartTime"
    icon="alberta-clock"
    [type]="dateType"
    (change)="changeStartTime($event)"
    [required]="true"
    [placeholder]="'patient.edit.deliveryStartTime_placeholder' | translate"
  ></itl-date-time>
  <itl-selection
    *ngIf="showDeliveryOptions && deliveryOptionSelectionItems.length"
    [title]="'order.deliveryOption' | translate"
    [values]="deliveryOptionSelectionItems"
    [(ngModel)]="order.deliveryOption"
    [formControl]="deliveryOption"
    [placeholder]="'order.chooseDeliveryOption' | translate"
    [required]="deliveryOptionRequired"
    icon="alberta-dot"
  >
  </itl-selection>
  <itl-textarea
    *ngIf="hasDeliveryNote"
    [(ngModel)]="order.deliveryNote"
    [formControl]="deliveryNote"
    [placeholder]="'patient.edit.deliveryNote_placeholder' | translate"
    icon="alberta-comment"
    [maxlength]="deliveryNoteMaxLength"
    [title]="'patient.edit.deliveryNote' | translate"
  ></itl-textarea>
  <itl-selection
    [title]="'address.deliveryAddress' | translate"
    [values]="adressesSelectionItems"
    [(ngModel)]="order.deliveryAddress"
    [formControl]="deliveryAddress"
    [compareFn]="compareAddresses"
    [placeholder]="'address.deliveryAddress_placeholder' | translate"
    icon="alberta-place"
    [required]="true"
    (change)="handleDeliveryAddressChange()"
  >
  </itl-selection>
  <button class="expandAddressButton" *ngIf="order.deliveryAddress" (click)="showAddressDetails = !showAddressDetails">
    <ion-icon [name]="showAddressDetails ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
    {{ 'address.changeAddress' | translate }}
  </button>
  <ng-container *ngIf="order.deliveryAddress && showAddressDetails">
    <itl-selection
      [title]="'address.gender' | translate"
      [(ngModel)]="order.deliveryAddress.gender"
      [values]="genderValues"
    ></itl-selection>
    <itl-selection
      [title]="'address.title' | translate"
      [(ngModel)]="order.deliveryAddress.title"
      [values]="titleValues"
    >
    </itl-selection>
    <itl-text
      [title]="'address.name' | translate"
      [(ngModel)]="order.deliveryAddress.name"
      [required]="true"
      [formControl]="form.controls['deliveryAddressName']"
    ></itl-text>
    <itl-text
      [title]="'address.additionalAddress' | translate"
      [(ngModel)]="order.deliveryAddress.additionalAddress"
    ></itl-text>
    <itl-text
      [title]="'address.additionalAddress2' | translate"
      [(ngModel)]="order.deliveryAddress.additionalAddress2"
    ></itl-text>
    <itl-text
      [title]="'address.address' | translate"
      [(ngModel)]="order.deliveryAddress.address"
      [required]="true"
      [formControl]="form.controls['deliveryAddressAddress']"
    ></itl-text
    ><itl-autocomplete
      name="deliveryAddressCity"
      #deliveryAddressPostalCodeIdAutocomplete
      [title]="'address.city' | translate"
      [placeholder]="'address.city_placeholder' | translate"
      [(selected)]="order.deliveryAddress.postalCodeId"
      [type]="'postalCode'"
      icon="alberta-region"
      [fullPageModal]="true"
      [(control)]="form.controls['deliveryAddressPostalCodeId']"
    ></itl-autocomplete>
    <itl-text
      [title]="'address.postalCode' | translate"
      [ngModel]="order.deliveryAddress.postalCode"
      [disabled]="true"
      [required]="true"
    ></itl-text>
    <itl-text
      [title]="'address.city' | translate"
      [ngModel]="order.deliveryAddress.city"
      [disabled]="true"
      [required]="true"
    >
    </itl-text>
  </ng-container>
</div>
